import device from './device'
import file from './file'
import time from './time'

export default {
    time,
    device,
    file
}